import { render } from "./CurrentShadowTeamPlayerSelection.vue?vue&type=template&id=128c8b90"
import script from "./CurrentShadowTeamPlayerSelection.vue?vue&type=script&lang=js"
export * from "./CurrentShadowTeamPlayerSelection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__